import * as actions from '../Actions/ControlLists';

export const controlListReducer = (state = {}, action) => {
    switch (action.type) {
        case actions.GET_CONTROL_LIST_DATA_REQUESTED:
            return {...state, isLoading: true, isError: false, controlList: []};
        case actions.GET_CONTROL_LIST_DATA_DONE:
            return {...state, isLoading: false, isError: false, controlList: action.payload};
        case actions.GET_CONTROL_LIST_DATA_FAILED:
            return {...state, isLoading: false, isError: true, error: action.payload};
        default:
            return state;
    }
    };